<template>
  <div class="d-flex flex-column justify-center w-100">
    <div class="d-flex justify-center">
      <v-img
        contain
        v-if="$route.params.status == 401"
        :src="UnauthorizedPage"
        height="400"
        width="400"
        class="my-12"
      ></v-img>
      <v-img
        contain
        v-else-if="$route.params.status == 403"
        :src="ForbiddenError"
        height="400"
        width="400"
        class="my-12"
      ></v-img>
      <v-img
        contain
        v-else
        :src="PageNotFound"
        height="400"
        width="400"
        class="my-12"
      ></v-img>
    </div>
    <div class="py-4 text-center">
      <h1 class="text-capitalize" v-if="$route.params.status == 401">
        401 - Unauthorized Error
      </h1>
      <h1 class="text-capitalize" v-else-if="$route.params.status == 403">
        403 - Forbidden Error
      </h1>
      <h1 class="text-capitalize" v-else>404 - page not found</h1>
      <v-btn class="primary white--text mt-6" @click="goBackToDashBoard"
        >Go Home</v-btn
      >
    </div>
  </div>
</template>

<script>
import ForbiddenError from "@/assets/forbidden-error.png";
import PageNotFound from "@/assets/page_not_found.png";
import UnauthorizedPage from "@/assets/Unauthorized-page.png";
import { getUserDetailsLocalStorage } from "@/utils/functions";

export default {
  data() {
    return {
      ForbiddenError,
      PageNotFound,
      UnauthorizedPage,
    };
  },
  methods: {
    goBackToDashBoard() {
      let userData = getUserDetailsLocalStorage();
      if (
        (userData && userData.role == "system_admin") ||
        userData.role == "account_manager"
      ) {
        this.$router.push({ name: "admin-dashboard" });
      } else {
        this.$router.push({ name: "client-dashboard" });
      }
    },
  },
  beforeCreate() {
    console.log(this.$route.params);
  },
};
</script>

<style></style>
